import $ from "jquery";

// Image Layout muss bei Normblatt Seite 2 und bei den Anwendungsbeispielen korrigiert werden
const $zusatzInformationen = $(".product-additionals, .anwendungsbeispiele-infobloecke");

const $rows = $zusatzInformationen.find("tr")
	.filter((_i: number, row: HTMLTableRowElement) => $(row).find("td.image-info-cell").length > 1);

// §HACK 15.05.2024/LT Um allen möglichen Netzwerkbedingungen und Systemen gerecht zu werden (oder es zu versuchen),
// muss die update Function an vielen verschiedenen Zeitpunkten aufgerufen werden.
updateElementAlignment();
$(() => updateElementAlignment);
$(window).on("resize", updateElementAlignment);
$rows.find("img").on("load", updateElementAlignment);

const observer = new MutationObserver(updateElementAlignment);

// Handler aufrufen, wenn ein Infoblock auf-/zugeklappt wird
$zusatzInformationen.find(".heading.toggle")
	.each((_i: number, el: HTMLElement) => observer.observe(el, { attributes: true }));

function updateElementAlignment() {
	$rows.each((_i: number, row: HTMLTableRowElement) => {
		for (let i = 1; true; i++) {
			const $elements = $(row).find(`td.image-info-cell > :nth-child(${i})`);

			if ($elements.length < 2) break;

			// Zuerst unsere Anpassungen zurücknehmen, damit sie nicht die maxHeight Ermittlung verfälschen
			$elements.css({ "height": "" });

			const heights = $elements.map((_i: number, el: HTMLElement) => el.scrollHeight).get();
			const maxHeight = Math.max(...heights);

			$elements.css({ "height": maxHeight + "px" });
		}
	});
}
